import { DOCUMENT } from '@angular/common';
import { Injectable, inject } from '@angular/core';

import { MediaConfig } from '@frontend/sports/common/client-config-data-access';
import { interpolateSingleBracesString } from '@frontend/sports/common/core/utils/string';
import { Page } from '@frontend/vanilla/core';

import { MatchSimulationUrlOptions } from './match-simulation.models';

@Injectable({ providedIn: 'root' })
export class MatchSimulationService {
    private localePath: string;
    private stylePath: string;
    private imagePath: string;

    private readonly _doc = inject(DOCUMENT);

    constructor(
        private mediaConfig: MediaConfig,
        private page: Page,
    ) {
        this.localePath = this.getAbsolutePath('/ClientDist/browser/assets/simulation/localizations');
        this.stylePath = this.getAbsolutePath('/ClientDist/browser/assets/simulation/styles/bundle.css');
        this.imagePath = this.getAbsolutePath('/{lang}/sports/api/simulation/getimageconfig');
    }

    getMatchSimulationUrl(options?: MatchSimulationUrlOptions): any {
        if (!options || !options.runningBallDataId) {
            return '';
        }

        const url = interpolateSingleBracesString(this.mediaConfig.matchSimulation.url, {
            partnerId: this.mediaConfig.matchSimulation.partnerId,
            userId: this.mediaConfig.matchSimulation.userId ?? '',
            eventId: options.runningBallDataId,
            homeTeam: this.encodePlayerName(options.homeTeam),
            awayTeam: this.encodePlayerName(options.awayTeam),
            width: options.width,
            height: options.height,
            lang: this.page.lang.substring(0, 2),
            csspath: this.stylePath,
            locdiff: this.localePath,
            imageconfig: this.imagePath,
        });

        return url;
    }

    private encodePlayerName(name?: string): string {
        if (!name) {
            return '';
        }

        return Array.prototype.map
            .call(name, (letter: string) => {
                return letter === ' ' ? '%C2%A0' : encodeURIComponent(letter);
            })
            .join('');
    }

    private getAbsolutePath(url: string): string {
        // https://grack.com/blog/2009/11/17/absolutizing-url-in-javascript/
        // Get absolute path
        const div = this._doc.createElement('div');
        div.innerHTML = '<a></a>';
        (<HTMLAnchorElement>div.firstChild).href = url.replace('{lang}', this.page.lang); // Ensures that the href is properly escaped
        // eslint-disable-next-line no-self-assign
        div.innerHTML = div.innerHTML; // Run the current innerHTML back through the parser

        return (<HTMLAnchorElement>div.firstChild).href;
    }
}
